const sortedWithOtherLast = (arr) => {
  const others = arr.filter(s => s === 'Other');
  const rest = arr.filter(s => s !== 'Other').sort((a, b) => a.localeCompare(b));
  return [...rest, ...others];
};

export const instrumentOptions = sortedWithOtherLast([
  "SCIEX 4500",
  "SCIEX 4000",
  "Revvity Qsight",
  "Waters Quattro Micro",
  "Waters Xevo TQD",
  "Waters TQ-S micro",
  "Waters Renata",
  "Other"
]);

export const reagentKitOptions = sortedWithOtherLast([
  "Neobase",
  "Neobase2",
  "Derivatized non-kit",
  "Xevo TQ-MS",
  "Non-Derivatized non-kit",
  "AccQ Tag",
  "Other"
]);